var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-logo",class:{'reverse': _vm.reverse}},[(_vm.reverse)?[(_vm.$slots.reverse)?[_vm._t("reverse")]:[_vm._t("default")]]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }